// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SeriesSlider.module.css */
.SimilarSeriesSection_sliderContainer__3y-hq {
  width: 86%;
  padding: 3rem 3rem;
}
.SimilarSeriesSection_Heading__8JE1V{
  color: white ;
  font-size: 24px;
}
.SimilarSeriesSection_swiper__zCjAj {
  width: 100%;
  height: 100%;
}

.SimilarSeriesSection_slide__kfeTd {
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  height: 250px;
}

.SimilarSeriesSection_slide__kfeTd:hover {
  transform: translateY(-5px);
}

.SimilarSeriesSection_seriesImage__XptQB {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* You may need to override some Swiper default styles */
.swiper-button-next,
.swiper-button-prev {
  color: #ffffff;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 40px !important;
  height: 40px !important;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px !important;
}

.swiper-pagination-bullet {
  background: #ffffff;
  opacity: 0.7;
}

.swiper-pagination-bullet-active {
  background: #ffffff;
  opacity: 1;
}

@media (max-width: 480px) {
  .SimilarSeriesSection_sliderContainer__3y-hq {
    width: 90%;
    padding: 1rem 1rem;
  }
}
@media (max-width: 800px) {
  .SimilarSeriesSection_sliderContainer__3y-hq {
    width: 90%;
    padding: 3rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/EpisodeScreen/Component/CSS/SimilarSeriesSection.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;;EAEE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;AACF","sourcesContent":["/* SeriesSlider.module.css */\n.sliderContainer {\n  width: 86%;\n  padding: 3rem 3rem;\n}\n.Heading{\n  color: white ;\n  font-size: 24px;\n}\n.swiper {\n  width: 100%;\n  height: 100%;\n}\n\n.slide {\n  position: relative;\n  cursor: pointer;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n  height: 250px;\n}\n\n.slide:hover {\n  transform: translateY(-5px);\n}\n\n.seriesImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* You may need to override some Swiper default styles */\n:global(.swiper-button-next),\n:global(.swiper-button-prev) {\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  width: 40px !important;\n  height: 40px !important;\n}\n\n:global(.swiper-button-next:after),\n:global(.swiper-button-prev:after) {\n  font-size: 20px !important;\n}\n\n:global(.swiper-pagination-bullet) {\n  background: #ffffff;\n  opacity: 0.7;\n}\n\n:global(.swiper-pagination-bullet-active) {\n  background: #ffffff;\n  opacity: 1;\n}\n\n@media (max-width: 480px) {\n  .sliderContainer {\n    width: 90%;\n    padding: 1rem 1rem;\n  }\n}\n@media (max-width: 800px) {\n  .sliderContainer {\n    width: 90%;\n    padding: 3rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sliderContainer": `SimilarSeriesSection_sliderContainer__3y-hq`,
	"Heading": `SimilarSeriesSection_Heading__8JE1V`,
	"swiper": `SimilarSeriesSection_swiper__zCjAj`,
	"slide": `SimilarSeriesSection_slide__kfeTd`,
	"seriesImage": `SimilarSeriesSection_seriesImage__XptQB`
};
export default ___CSS_LOADER_EXPORT___;
